import Badge from 'client/components/core/Badge'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import CommonBlogPostTitle from 'common/components/entities/BlogPostTitle/BlogPostTItleNew'
import { BlogPostTitleInterface } from 'common/types/entities/BlogPostTitleInterface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EntityProps } from '../../../types'

function BlogPostTitleNew({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BlogPostTitleInterface>) {
  const { t } = useTranslation()
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <>
        <CommonBlogPostTitle
          title={t('entities.blog_post_title.placeholder')}
          attrId={entity.htmlAttrId}
          fontSize={entity.fontSize}
          fontFamily={entity.fontFamily}
          fontStyle={entity.fontStyle}
          fontWeight={entity.fontWeight}
          mobileFontSize={entity.mobileFontSize}
          mobileFontFamily={entity.mobileFontFamily}
          mobileFontStyle={entity.mobileFontStyle}
          mobileFontWeight={entity.mobileFontWeight}
          lineHeight={entity.lineHeight}
          mobileLineHeight={entity.mobileLineHeight}
          color={entity.color}
          mobileColor={entity.mobileColor}
          alignSelf={entity.alignSelf}
          mobileAlignSelf={entity.mobileAlignSelf}
        />
        <Badge wide>
          {t('entities.blog_post_title.warnings.do_not_remove')}
        </Badge>
      </>
    </BaseEntityNew>
  )
}

export default BlogPostTitleNew
